/**
 * Issue #528 — Per-workspace CheckVariable overrides.
 * Mirrors the runtime shape of `IntegrationCheckConfig` plus the check's
 * declared variable schema so the UI can render a form in one round-trip.
 */
import { z } from 'zod/v3';

export const CheckVariableTypeSchema = z.enum([
  'text',
  'number',
  'boolean',
  'select',
  'multi-select',
]);
export type CheckVariableType = z.infer<typeof CheckVariableTypeSchema>;

export const CheckVariableDTOSchema = z.object({
  id: z.string(),
  label: z.string(),
  type: CheckVariableTypeSchema,
  required: z.boolean().optional(),
  default: z.union([z.string(), z.number(), z.boolean(), z.array(z.string())]).optional(),
  helpText: z.string().optional(),
  placeholder: z.string().optional(),
  options: z
    .array(z.object({ value: z.string(), label: z.string() }))
    .optional(),
});
export type CheckVariableDTO = z.infer<typeof CheckVariableDTOSchema>;

export const CheckConfigDTOSchema = z.object({
  checkId: z.string(),
  checkName: z.string(),
  provider: z.string(),
  /** Schema for the form. */
  variables: z.array(CheckVariableDTOSchema),
  /** Sparse map of user-set values keyed by `CheckVariable.id`. */
  config: z.record(z.unknown()),
  updatedAt: z.date().nullable(),
  updatedBy: z.string().nullable(),
});
export type CheckConfigDTO = z.infer<typeof CheckConfigDTOSchema>;
